import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3729401f&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=3729401f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3729401f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3729401f')) {
      api.createRecord('3729401f', component.options)
    } else {
      api.reload('3729401f', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=3729401f&scoped=true", function () {
      api.rerender('3729401f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/view/components/TabPrizeView/components/ModalDetailsReturns/main.vue"
export default component.exports